import React, {
  useContext,
  useEffect,
  useState,
  createContext
} from 'react';
import deepmerge from 'deepmerge';

import { setFromSession } from 'wtb-utils';

const AuthContext = createContext();

const defaultState = {
  authToken: null,
  authProvider: null,
  authSessionId: null,
  preselectedAccount: null
};

const AuthProvider = ({ children, initialState: state = {} }) => {
  const initialState = deepmerge(defaultState, state);

  const [ authToken, setAuthToken ] = useState(initialState.authToken);
  const [ authProvider, setAuthProvider ] = useState(initialState.authProvider);
  const [ authSessionId, setAuthSessionId ] = useState(initialState.authSessionId);
  const [ preselectedAccount, setPreselectedAccount ] = useState(initialState.preselectedAccount);

  useEffect(() => {
    if (!authToken) return;

    setFromSession('authToken', authToken);
  }, [ authToken ]);

  const _setAuthToken = (token) => {
    setFromSession('authToken', token);
    setAuthToken(token);
  };

  return (
    <AuthContext.Provider
      value={{
        authToken, setAuthToken: _setAuthToken,
        authProvider, setAuthProvider,
        authSessionId, setAuthSessionId,
        preselectedAccount, setPreselectedAccount
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const AuthConsumer = AuthContext.Consumer;

const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuthContext must be used within a AuthProvider');
  }

  return context;
};

export {
  AuthContext, AuthProvider, AuthConsumer, useAuthContext
};
